import { ILenderContactData, IPresentationLenderContactData } from '../../../../types/contacts/ILenderContact';
import React from 'react';
import { BodyText, Button, DataGrid, NavigationItem } from 'ui-toolkit';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { formatPhoneNumber } from '../../../../utilities/shared/formatPhoneNumber';
import { getListOfPresentationContacts } from '../../../../types/contacts/IPresentationContactData';
import { IContactFunctionData } from '../../../../types/contacts/IContactFunctionData';

interface ILenderOrderContactsTableProps {
  data: ILenderContactData[];
  loading: boolean;
  onEditContact: (contact: ILenderContactData) => void;
  contactFunctions: IContactFunctionData[];
}

export const LenderOrderContactsTable: React.FC<ILenderOrderContactsTableProps> = ({
  data,
  loading,
  onEditContact,
  contactFunctions,
}) => {
  const tableData: IPresentationLenderContactData[] = getListOfPresentationContacts(
    data,
    contactFunctions.filter((func) => func.isLender).map((func) => func.id)
  );

  const columns: IBootstrapTableColumnProps[] = [
    {
      text: 'Function',
      dataField: 'function',
      sort: true,
      formatter: (cell) => <>{contactFunctions.find((func) => func.id === cell)?.label}</>,
    },
    {
      text: 'Name',
      dataField: 'firstName',
      sort: true,
      formatter: (cell, row) => {
        const contact = row as IPresentationLenderContactData;
        return <>{`${contact.firstName} ${contact.lastName}`}</>;
      },
    },
    {
      text: 'Email',
      dataField: 'email',
      sort: true,
      formatter: (cell) => <NavigationItem text={cell} isActive isInline href={`mailto:${cell}`} />,
    },
    {
      text: 'Phone',
      dataField: 'phoneNumber',
      sort: true,
      formatter: (cell) => <>{formatPhoneNumber(cell || '')}</>,
    },
    {
      text: 'Notes',
      dataField: 'notes',
      sort: false,
      formatter: (cell) => <BodyText style={{ whiteSpace: 'pre-line' }}>{cell}</BodyText>,
    },
    {
      text: 'Options',
      dataField: 'id',
      formatter: (cell, row) => (
        <Button intent={'ghost'} onClick={() => onEditContact(row as ILenderContactData)}>
          <FontAwesomeIcon icon={faEdit} />
        </Button>
      ),
    },
  ];

  return <DataGrid columns={columns} data={tableData} keyField={'key'} loading={loading} />;
};
